function rollingDice() {
  // Math.random()(최대값 - 최소값) + 최소값]
  const max = 6;

  const diceResult = Math.floor(Math.random() * max) + 1;
  return diceResult;
}

export default rollingDice;
